import { useQuery } from "@tanstack/react-query"
import { API } from "config"

const useOrders = (page = 1, term = null, type = null, status = null, period = [null, null]) => {
    return useQuery({
        queryKey: ['orders', page, term, type, status, period],
        queryFn: async () => {
            const params = new URLSearchParams()
            if(page) params.append('page', page)
            if(term) params.append('term', term)
            if(type) params.append('type', type)
            if(status) params.append('status', status)
            if(period[0] && period[1]){
                params.append('period[0]', period[0])
                params.append('period[1]', period[1])
            }

            const response = await API.get(`/orders?${params.toString()}`)
            return response?.data
        },
        staleTime: 1000 * 60
    })
}

export default useOrders
